import noticeDetail       from '../pages/notice/detail'
import noticeList       from '../pages/notice/list'
import noticeRegister       from '../pages/notice/register'

export default [
    {
        path: '/noticeDetail', 
        name: 'noticeDetail',
        component: noticeDetail,
    },
    {
        path: '/noticeList', 
        name: 'noticeList',
        component: noticeList,
    },
    {
        path: '/noticeRegister', 
        name: 'noticeRegister',
        component: noticeRegister,
    }

]
